export function Text({ children }: { children: React.ReactNode }) {
    return (
        <p className="text-sm font-semibold m-0 text-gray-600">{children}</p>
    );
}

export function TextLabel({ children, icon }: { children: React.ReactNode, icon?: React.ReactNode }) {
    return (
        <div className="flex gap-1 items-center">
            {icon}
            <p className="text-sm font-semibold m-0">{children}</p>
        </div>
    );
}
